import { render, staticRenderFns } from "./ShowShape.vue?vue&type=template&id=ff057476"
import script from "./ShowShape.vue?vue&type=script&lang=js"
export * from "./ShowShape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports